<script>
import DemoPerson1 from '@/assets/img/demo-person-1.png';
import DemoPerson2 from '@/assets/img/demo-person-2.png';
import DemoPerson3 from '@/assets/img/demo-person-3.png';
import Typography from '../../base/Typography';
import Button from '../../base/Button';

export default {
  components: {
    Typography,
    Button,
  },

  data() {
    return {
      sectionActive: [],
      DemoPerson1,
      DemoPerson2,
      DemoPerson3,
    };
  },

  mounted() {
    this.onScroll();
    window.addEventListener('scroll', this.onScroll, true);
  },

  unmounted() {
    window.removeEventListener('scroll', this.onScroll, true);
  },

  methods: {
    onScroll() {
      const scrollY = window.scrollY;
      const section1 = document.getElementById('request-section') ?? {
        offsetTop: 0,
      };

      const section1Top = section1.offsetTop + 100;
      const section1Height = section1.offsetHeight;
      const section1Bottom = section1Top + section1Height;

      const checkPoint = scrollY + window.innerHeight - 100;

      if (checkPoint >= section1Top && scrollY <= section1Bottom) {
        this.sectionActive.push(1);
      }
    },

    onOpenDemoVideo() {
      this.$emit('openDemoVideo');
    },
  },
};
</script>
<!-- eslint-disable vue/no-undef-components -->
<template>
  <div
    id="request-section"
    class="contack-bg tw-bg-purple-200 tw-px-6 tw-bg-repeat"
  >
    <div
      class="tw-max-w-container-1 tw-mx-auto tw-min-h-[543px] tw-flex tw-items-center tw-justify-center tw-text-center"
    >
      <div>
        <div class="tw-flex tw-gap-4 tw-items-center tw-justify-center">
          <div class="tw-w-[100px]">
            <img :src="DemoPerson1" alt="Demo Person" class="tw-max-w-full" />
          </div>
          <div class="tw-w-[100px]">
            <img :src="DemoPerson2" alt="Demo Person" class="tw-max-w-full" />
          </div>
          <div class="tw-w-[100px]">
            <img :src="DemoPerson3" alt="Demo Person" class="tw-max-w-full" />
          </div>
        </div>
        <Typography
          variant="headline-3"
          class="tw-translate-y-0 tw-transition-all tw-duration-700"
          :class="{
            'tw-translate-y-[200px] tw-opacity-0 tw-transition-none':
              !sectionActive.includes(1),
          }"
        >
          Want to see the platform in action?
        </Typography>
        <div
          class="tw-mt-8 tw-grid md:tw-flex tw-justify-center tw-items-center tw-gap-8"
        >
          <div
            class="tw-translate-y-0 tw-transition-all tw-duration-700"
            :class="{
              'tw-translate-y-[200px] tw-opacity-0 tw-transition-none':
                !sectionActive.includes(1),
            }"
          >
            <Button
              variant="gray-8"
              size="xl"
              class="tw-min-w-[360px] tw-w-full"
              @click="onOpenDemoVideo"
            >
              <div class="tw-flex tw-items-center tw-justify-center tw-gap-2">
                <div>Tour the platform</div>
                <div>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="tw-stroke-white"
                  >
                    <path
                      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.5 8.96533C9.5 8.48805 9.5 8.24941 9.59974 8.11618C9.68666 8.00007 9.81971 7.92744 9.96438 7.9171C10.1304 7.90525 10.3311 8.03429 10.7326 8.29239L15.4532 11.3271C15.8016 11.551 15.9758 11.663 16.0359 11.8054C16.0885 11.9298 16.0885 12.0702 16.0359 12.1946C15.9758 12.337 15.8016 12.449 15.4532 12.6729L10.7326 15.7076C10.3311 15.9657 10.1304 16.0948 9.96438 16.0829C9.81971 16.0726 9.68666 15.9999 9.59974 15.8838C9.5 15.7506 9.5 15.512 9.5 15.0347V8.96533Z"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </Button>
          </div>
          <div
            class="tw-translate-y-0 tw-transition-all tw-duration-700"
            :class="{
              'tw-translate-y-[200px] tw-opacity-0 tw-transition-none':
                !sectionActive.includes(1),
            }"
          >
            <a href="/contact">
              <Button size="xl" class="tw-min-w-[360px] tw-w-full">
                Book a demo
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
